"use client"

import { useEffect, useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { usePermissions } from '@/shared/hooks/use-permissions'

export function SmartRedirect() {
  const navigate = useNavigate()
  const { isPermissionsLoaded, getFirstAvailablePage } = usePermissions()
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    if (!isPermissionsLoaded || isRedirecting) return

    const firstAvailablePage = getFirstAvailablePage()

    if (firstAvailablePage) {
      setIsRedirecting(true)
      navigate({ to: firstAvailablePage.path, replace: true })
        .then(() => {
        })
        .catch(() => {
          // Get another available page as fallback
          const fallbackPage = getFirstAvailablePage()
          if (fallbackPage && fallbackPage.path !== firstAvailablePage.path) {
            navigate({ to: fallbackPage.path, replace: true }).catch(() => {
              navigate({ to: '/forbidden', replace: true })
            })
          } else {
            navigate({ to: '/forbidden', replace: true })
          }
        })
    } else {
      // If user has no permissions, redirect to forbidden page
      setIsRedirecting(true)
      navigate({ to: '/forbidden', replace: true }).catch(() => {
        // If forbidden page fails, try to go to login
        navigate({ to: '/auth/login', replace: true })
      })
    }
  }, [isPermissionsLoaded, getFirstAvailablePage, navigate, isRedirecting])

  // Don't show loading spinner - return null and let redirect happen
  // This prevents flash of loading screen on the index route
  return null
}
